import { render, staticRenderFns } from "./Neighbourhood.vue?vue&type=template&id=32dd6b3f&scoped=true&"
import script from "./Neighbourhood.vue?vue&type=script&lang=js&"
export * from "./Neighbourhood.vue?vue&type=script&lang=js&"
import style0 from "./Neighbourhood.vue?vue&type=style&index=0&id=32dd6b3f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32dd6b3f",
  null
  
)

export default component.exports